import * as React from 'react'
import useIntersectionObserver from '../userIntersectionObserver'
import './education_component.scss'

var everVisible = false

export default function EducationComponent (props) {
  const [ref, isVisible] = useIntersectionObserver(
    { threshold: 0.1 },
    250
  )

  if (isVisible) {
    everVisible = true
  }

  return (
    <article
      ref={ref}
      className='education_record'
      style={{
        opacity: !everVisible ? 0 : 1,
        transform: !everVisible ? 'translateY(18px)' : 'translateY(0)',
        visibility: !everVisible ? 'hidden' : 'visible'
      }}
    >
      <div className='education_record_media'>
        <div className='education_record_index'>01</div>
        <img
          src={props.imagePath}
          alt={`Institute Image of Sam Varghese - ${props.institution}`}
          loading='lazy'
        />
      </div>

      <div className='education_record_body'>
        <div className='education_record_topline'>
          <span>ACADEMIC RECORD</span>
          <span>ENGINEERING + MANAGEMENT</span>
        </div>

        <h2>{props.institution}</h2>
        <p className='education_record_program'>{props.education_sub_heading}</p>
        <p className='education_record_description'>{props.description}</p>

        <div className='education_record_meta'>
          <div>
            <small>DISCIPLINE</small>
            <strong>Technology &amp; Management</strong>
          </div>
          <div>
            <small>STATUS</small>
            <strong>Graduated</strong>
          </div>
          <div>
            <small>LOCATION</small>
            <strong>Mumbai, India</strong>
          </div>
        </div>

        <button
          type='button'
          className='education_record_link'
          onClick={() => window.open(props.link, '_blank')}
        >
          VIEW INSTITUTION <span>↗</span>
        </button>
      </div>
    </article>
  )
}
